import { basePermissionManagerApi as api } from '../basePermissionManagerApi';
export const addTagTypes = ['User'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getUsers: build.query<GetUsersApiResponse, GetUsersApiArg>({
        query: (queryArg) => ({
          url: `/users`,
          params: {
            FirstName: queryArg.firstName,
            LastName: queryArg.lastName,
            Email: queryArg.email,
            ResourceTypes: queryArg.resourceTypes,
          },
        }),
        providesTags: ['User'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as baseGeneratedApi };
export type GetUsersApiResponse =
  /** status 200 OK */ ServiceAuthorisationDomainModelsUserRead[];
export type GetUsersApiArg = {
  firstName?: string;
  lastName?: string;
  email?: string;
  resourceTypes?: string[];
};
export type ServiceAuthorisationDomainModelsUserProfile = {
  firstName?: string | null;
  lastName?: string | null;
  login: string | null;
  email?: string | null;
  state?: string | null;
  countryCode?: string | null;
  manager?: string | null;
  displayName?: string | null;
  secondEmail?: string | null;
};
export type ServiceAuthorisationDomainModelsUserProfileRead = {
  firstName?: string | null;
  lastName?: string | null;
  login: string | null;
  email?: string | null;
  state?: string | null;
  countryCode?: string | null;
  timeZone?: string | null;
  manager?: string | null;
  displayName?: string | null;
  secondEmail?: string | null;
};
export type ServiceAuthorisationDomainModelsUser = {
  id: string | null;
  status: string | null;
  profile: ServiceAuthorisationDomainModelsUserProfile;
  resourceTypes?: string[] | null;
};
export type ServiceAuthorisationDomainModelsUserRead = {
  id: string | null;
  status: string | null;
  profile: ServiceAuthorisationDomainModelsUserProfileRead;
  resourceTypes?: string[] | null;
};
export const { useGetUsersQuery } = injectedRtkApi;
